import { render } from "./formularioBuscarTarjeta.vue?vue&type=template&id=5bdb6658"
import script from "./formularioBuscarTarjeta.vue?vue&type=script&lang=js"
export * from "./formularioBuscarTarjeta.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__